"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Direction = void 0;
var Direction;
(function (Direction) {
  Direction["Right"] = "to right";
  Direction["Left"] = "to left";
  Direction["Down"] = "to bottom";
  Direction["Up"] = "to top";
})(Direction = exports.Direction || (exports.Direction = {}));